// extracted by mini-css-extract-plugin
module.exports = {"option":"GetStartedSurvey_option__2anDH","option__label":"GetStartedSurvey_option__label__AB3ZI","active":"GetStartedSurvey_active__SJTDN"};